import { useParams } from 'react-router';
import type { ShiftType } from 'src/api/ShiftTypeService';
import { useShiftTypesEntry } from '@stores/shiftTypeStore';

const useShiftTypes = (): {
    shiftTypes: ShiftType[] | undefined;
    departmentId: string | undefined;
    isLoadingShiftTypes: boolean;
    fetchShiftTypes: () => void;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const {
        response: shiftTypes,
        isLoading: isLoadingShiftTypes,
        requestApiCall: fetchShiftTypes,
    } = useShiftTypesEntry(departmentId);

    return {
        shiftTypes,
        departmentId,
        isLoadingShiftTypes,
        fetchShiftTypes,
    };
};

export default useShiftTypes;
